import { Loading } from '@components/common/Loading/Loading';
import { Secured } from '@components/Secured/Secured';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { TaskTablet } from '@/pages/TaskTablet/components/TaskTablet';
import { vaccination } from '@/shared/security/permissions/vaccination';

const LazyVaccination = lazy(() =>
  import('./TaskTabletPage').then((module) => ({
    default: module.TaskTabletPage,
  })),
);

const baseRoute: RouteObject = {
  path: '/',
  element: <Loading children={<LazyVaccination />} />,
  children: [],
};

const vaccinationTabletRoutes = [
  {
    path: '/',
    element: (
      <Secured
        security={{
          permissions: [vaccination.task.eventAndIndividualCompletion],
        }}>
        <TaskTablet />
      </Secured>
    ),
  },
];

baseRoute.children = [...vaccinationTabletRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const VaccinationTabletRoutes = routes;
